export default __webpack_public_path__ + "static/media/3.12df114f.jpg";